import Landing from "./components/Landing";
import Hero from "./components/Hero";
import About from "./components/About";
import Properties from "./components/Property";
import Flexible from "./components/Flexible";
import PropertyForm from "./components/PropertyForm";
import Footer from "./components/Footer";
import { library } from '@fortawesome/fontawesome-svg-core';
import { fab } from '@fortawesome/free-brands-svg-icons';
import { faFax, faPhone, faLocationPin } from '@fortawesome/free-solid-svg-icons'

library.add(fab, faFax, faPhone, faLocationPin)
console.log(library)

function App() {
  return (
    <Landing>
      <section>
        <Hero />
      </section>
      <section>
        <About />
      </section>
      <section>
        <Properties />
      </section>
      <section>
        <Flexible />
      </section>
      <section>
        <PropertyForm 
          // onSave={this.handleSubmit}
          />
      </section>
      <section>
        <Footer/>
      </section>
    </Landing>
  );
}

export default App;
